import axios from "axios";
import Config from "../../../config";
import {
  callNotification,
  errorCode,
  handleApiError,
  handleAxiosError,
  getUTCOffset,
} from "../../constants";
import {
  setIsDashboardScheduleModal,
  setIsDashboardScheduleTemplate,
  setScheduleCurrentStep,
} from "../ApiCall/apiCall";
import { setClearTemplateData, setIsDashboard } from "../dashboard/Tab1";
import { setSelectLogicalBrandValue } from "../LogicalGroup";

export const setScheduleDuration = (value, obj) => {
  let updateScheduleObj = { ...obj };
  updateScheduleObj.ScheduleDuration = value;

  return (dispatch) => {
    dispatch({
      type: "SET_SCHEDULE_DURATION",
      scheduleObj: updateScheduleObj,
    });
  };
};
export const setScheduleDateTime = (value, obj) => {
  let updateScheduleObj = { ...obj };
  updateScheduleObj.ScheduleDateTime = value;

  return (dispatch) => {
    dispatch({
      type: "SET_SCHEDULE_DURATION",
      scheduleObj: updateScheduleObj,
    });
  };
};

export const setScheduleReport = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_SCHEDULE_DURATION",
      scheduleObj: value,
    });
  };
};
export const setScheduleLoader = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_SCHEDULE_LOADER",
      payload: value,
    });
  };
};
export const setScheduleHiddenFilter = (value, obj) => {
  let updateScheduleObj = { ...obj };
  updateScheduleObj.hidden_filter = value;
  return (dispatch) => {
    dispatch({
      type: "SET_SCHEDULE_HIDDEN_FILTER",
      scheduleObj: updateScheduleObj,
    });
  };
};

export const setScheduleQuickFilter = (value, obj) => {
  let updateScheduleObj = { ...obj };
  updateScheduleObj.quick_filter = value;
  return (dispatch) => {
    dispatch({
      type: "SET_SCHEDULE_QUICK_FILTER",
      scheduleObj: updateScheduleObj,
    });
  };
};

export const setBrandsCategoryList = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_BRANDS_CATEGORY_LIST", payload: value });
  };
};
export const setSelectedBrands = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_SELECTED_BRANDS", payload: value });
  };
};
export const setCheckedAccounts = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_CHECKED_ACCOUNTS", payload: value });
  };
};
export const setSelectedBrandsGroup = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_SELECTED_BRANDS_GROUP", payload: value });
  };
};
export const setSelectedCompetitorBrands = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_SELECTED_COMETITOR_BRANDS", payload: value });
  };
};
export const setTemplateMetaData = (obj) => {
  let updateTemplateMeta = obj;
  return (dispatch) => {
    dispatch({
      type: "SET_TEMPLATE_META_DATA",
      templateMetaDeta: updateTemplateMeta,
    });
  };
};
export const setIsPdfPreview = (value, obj) => {
  let updateTemplateObj = { ...obj };
  updateTemplateObj.isPdfPreview = value;
  if (!value) {
    updateTemplateObj.pdfEditorPanelSatus = false;
    updateTemplateObj.pdfEditorPanelType = null;
  }

  return (dispatch) => {
    dispatch({
      type: "SET_TEMPLATE_OBJECT",
      templateObj: updateTemplateObj,
    });
  };
};
export const setBrandsList = (value, obj) => {
  return (dispatch) => {
    dispatch({
      type: "SET_BRANDS_LIST",
      templateObj: value,
    });
  };
};
export const setPdfEditorPanel = (status, mode, obj) => {
  let updateTemplateObj = { ...obj };
  updateTemplateObj.pdfEditorPanelSatus = status;
  updateTemplateObj.pdfEditorPanelType = mode;

  return (dispatch) => {
    dispatch({
      type: "SET_TEMPLATE_OBJECT",
      templateObj: updateTemplateObj,
    });
  };
};
export const setPdfEditorObject = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_PDF_EDITOR_OBJECT",
      pdfEditorObj: value,
    });
  };
};

export const setWidgetNotes = (value, obj) => {
  return (dispatch) => {
    dispatch({
      type: "SET_WIDGET_NOTE",
      widget_notes: value,
    });
  };
};
export const setWidgetNotesFromSectionFetch = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_WIDGET_NOTE_SECTION",
      widget_notes: value,
    });
  };
};
export const setWidgetNoteData = (
  value,
  index,
  panes,
  sectionIndex,
  widgetIndex,
  widgetId,
  widgetNotesObj
) => {
  const updatePanes = [...panes];
  if (
    sectionIndex !== null &&
    sectionIndex !== undefined &&
    updatePanes[index].sections
  ) {
    updatePanes[index].sections[sectionIndex].widgets[widgetIndex].note = value;
  } else {
    updatePanes[index].section[0].widgets[widgetIndex].note = value;
  }
  let updatedWidgetNotesObj = null;
  if (!widgetNotesObj) {
    updatedWidgetNotesObj = [
      {
        widget_id: widgetId,
        note: value,
      },
    ];
  } else {
    updatedWidgetNotesObj = widgetNotesObj;
    let index = widgetNotesObj?.findIndex((w) => w?.widget_id === widgetId);
    if (index >= 0) {
      updatedWidgetNotesObj[index].note = value;
    } else {
      updatedWidgetNotesObj.push({
        widget_id: widgetId,
        note: value,
      });
    }
    updatedWidgetNotesObj = updatedWidgetNotesObj?.filter((el) => el?.note);
  }
  return (dispatch) => {
    dispatch(setWidgetNotes(updatedWidgetNotesObj));
    dispatch({ type: "SET_WIDGET_GRAPH_DATA", panes: updatePanes });
  };
};

export const getWidgetNoteData = (value, widgetId) => {
  let updatedWidgetNoteObj = {
    widget_id: widgetId,
    note: value,
  };
  return updatedWidgetNoteObj;
};

export const setReportSearchsGroup = (value) => {
  return (dispatch) => {
    dispatch({ type: "SET_REPORT_SEARCH", payload: value });
  };
};

// for Report search Email Id
export const reportSearchEmails = (ptoken) => {
  let errorMessage;
  return async (dispatch) => {
    let body = {
      ptoken: ptoken?.ptoken,
      utcoffset: getUTCOffset(),
    };
    let url = `${Config.config1.api_link}/template/report-metadata`;
    await axios
      .post(url, body)
      .then((response) => {
        if (response?.status === 200) {
          dispatch(setReportSearchsGroup(false));
          if (response?.data?.status === "successful") {
            dispatch({
              type: "SET_REPORT_SEARCH_RESULT",
              payload: response?.data?.result,
            });
          }

          // Use the new error handler which includes errorCode 21 handling
          const errorResult = handleApiError(response, dispatch);
          if (errorResult.hasError) {
            // Error notification is handled automatically by handleApiError
            // console.log(
            //   `Report Search API Error: ${errorResult.errorCode} - ${errorResult.errorMessage}`
            // );
          }
        } else {
          dispatch(setReportSearchsGroup(false));
          callNotification(response?.data?.reason, "error");
        }
      })
      .catch((error) => {
        dispatch(setReportSearchsGroup(false));
        handleAxiosError(error, dispatch);
      });
  };
};

// for report generate and scheduling
export const scheduleReport = (payloadOption, extraObj) => {
  let errorMessage;
  let brands = payloadOption?.brand_list?.columns
    ? payloadOption?.brand_list?.columns
    : payloadOption?.brand_list
    ? payloadOption?.brand_list
    : payloadOption?.global_brands;
  let single_brands = [];
  let brandsGroupName = [];

  if (!payloadOption?.brand_list) {
    brandsGroupName =
      brands && brands[0]?.brand_group_name
        ? [
            {
              brand_group_name: brands[0]?.brand_group_name,
            },
          ]
        : single_brands?.push({
            brand_id: brands && brands[0]?.brand_id && brands[0]?.brand_id,
            brand_name:
              brands && brands[0]?.brand_name && brands[0]?.brand_name,
          });
  } else {
    if (brands && brands[0]?.competitor) {
      single_brands.push({
        brand_id: brands[0]?.name,
        brand_name: brands[0]?.brand_name,
      });
    } else {
      brands &&
        brands?.map((el) => {
          if (el?.group || el?.brand_group_name) {
            brandsGroupName.push({
              brand_group_name: el?.brand_group_name,
            });
          }
        });

      brands?.map((el) => {
        if (!el?.group) {
          single_brands.push({
            brand_id: el?.brand_id ? el?.brand_id : el?.name,
            brand_name: el?.brand_name
              ? el?.brand_name
              : el?.brand_friendly_name,
          });
        }
      });
    }
  }
  return async (dispatch) => {
    let body = {
      ptoken: payloadOption?.auth_params?.ptoken,
      template_id: payloadOption?.template_id,
      account_list: payloadOption?.account_list,
      brand_list:
        single_brands && single_brands[0]?.brand_id ? single_brands : null,
      brand_groups: brandsGroupName?.length > 0 ? brandsGroupName : null,
      comp_brand_list: brands[0]?.competitor ? brands[0]?.competitorList : null,

      comp_agg: null,
      frequency: payloadOption?.scheduleObject?.ScheduleType,
      email_ids: payloadOption?.scheduleObject?.selectedEmails,

      filters: payloadOption?.filters,
      quick_filter: payloadOption?.quick_filter,
      hidden_filter: payloadOption?.hidden_filter,
      widget_notes: payloadOption?.widgetNotes,

      start_date: payloadOption?.start_date,
      end_date: payloadOption?.end_date,
      data_duration: payloadOption?.scheduleObject?.selectedDataDuration,

      schedule_date: payloadOption?.scheduleObject?.scheduleDateTime,

      schedule_days: payloadOption?.scheduleObject?.scheduleDays,
      schedule_month: payloadOption?.scheduleObject?.scheduleMonth,
      is_scheduled: payloadOption?.type === "ScheduleReport" ? 1 : 0,

      schedule_json: payloadOption?.scheduleObject?.ScheduleDetails,

      utcoffset: payloadOption?.scheduleObject?.timeOffset
        ? payloadOption?.scheduleObject?.timeOffset
        : 330,
      orientation: "landscape",
      profile_filters: payloadOption?.profile_filters
        ? payloadOption?.profile_filters
        : null,
      utcoffset: getUTCOffset(),
    };

    dispatch(setScheduleLoader(true));
    let url = `${Config.config1.api_link}/template/schedule`;
    await axios
      .post(url, body)
      .then((response) => {
        if (response?.status === 200) {
          if (response?.data?.status === "successful") {
            dispatch(setScheduleLoader(false));

            dispatch(setSelectedBrandsGroup([]));
            dispatch(setSelectedBrands([]));
            dispatch(setSelectedCompetitorBrands([]));
            let updateselectValue = { ...extraObj?.selectLogicalBrandValue };
            updateselectValue["global_dashboard"].data = null;
            dispatch(setSelectLogicalBrandValue(updateselectValue));
            dispatch(setBrandsCategoryList(null));
            dispatch(
              setScheduleReport({
                ...extraObj?.scheduleObj,
                selectedEmails: [],
                selectedFrequency: null,
                type: "GenerateNow",
                ScheduleType: null,
                IsScheduled: false,
                startDate: null,
                endDate: null,
                scheduleDay: null,
                scheduleMonth: null,
                scheduleTime: null,
                selectedDataDuration: null,
                scheduleDateTime: null,
                scheduleDate: null,
                reportDeliveryTime: {
                  startTime: "09:00 AM",
                  endTime: "06:00 PM",
                },
                ScheduleDetails: JSON.stringify({
                  timeOffsetText: "(GMT+05:30:00) Asia/Kolkata",
                }),
                TimeOffsetText: "(GMT+05:30:00) Asia/Kolkata",
                quick_filter: null,
              })
            );
            let templateObj = {
              brands: [],
              duration: null,
              filters: [],
              isPdfPreview: false,
              pdfEditorPanelSatus: false,
              pdfEditorPanelType: null,
              is_schedule_preview_list: false,
              is_schedule_preview_dashboard: false,
            };
            dispatch(setIsPdfPreview(false, templateObj));
            dispatch(setIsDashboardScheduleModal(false));
            dispatch(setIsDashboardScheduleTemplate(null));
            dispatch(setScheduleCurrentStep(0));

            if (
              (window.location.pathname === "/dashboard" ||
                window.location.pathname === "/pin-dashboard") &&
              extraObj?.isDashboardScheduleTemplate?.already_opened_dashboard
            ) {
              let updatedPanes = [...extraObj?.panes]; // Deep copy to avoid mutation
              let pane = updatedPanes[extraObj?.index];

              if (pane?.sections) {
                // Loop through all sections
                updatedPanes[extraObj?.index]?.sections?.forEach((section) => {
                  section.widgets?.forEach((widget) => {
                    widget.note = widget?.original_note;
                    widget.original_note = null;
                  });
                });
              } else if (pane?.section?.[0]) {
                // Single section — access section[0].widgets
                updatedPanes[extraObj?.index]?.section[0]?.widgets?.forEach(
                  (widget) => {
                    widget.note = widget?.original_note;
                    widget.original_note = null;
                  }
                );
              }
              // updatedPanes[extraObj?.index].widget_notes = null;
              //to go back to the opened dashboard
              dispatch(setIsDashboard(true, extraObj?.index, updatedPanes));
              dispatch(setWidgetNotes(null));
            } else {
              dispatch(
                setClearTemplateData(null, extraObj?.index, extraObj?.panes)
              );
              dispatch({ type: "SET_TEMPLATE_DATA", payload: null });
            }

            // Template Data null for PdfHeader
            dispatch(setTemplateMetaData(null));

            if (
              payloadOption?.auth_params?.v3 &&
              window.location.pathname === "/schedule"
            ) {
              if (window?.parent) {
                window?.parent?.postMessage(
                  {
                    eventCode: 3, // 3 For Scheduled
                    message: response?.data?.message,
                    status: "successful",
                  },
                  "*" //"http://localhost:4200"
                );
                // Use target origin instead of *
              }
            } else {
              callNotification(response?.data?.message, "successful");
            }
          }

          // Use the new error handler which includes errorCode 21 handling
          const errorResult = handleApiError(response, dispatch, {
            suppressNotification: payloadOption?.auth_params?.v3, // Suppress if v3 (parent window handles it)
            customErrorHandlers: payloadOption?.auth_params?.v3
              ? {
                  // Custom handler for v3 mode - send messages to parent window
                  9: (errorCodeValue, errorMessage, response, dispatch) => {
                    if (window?.parent) {
                      window?.parent?.postMessage(
                        {
                          eventCode: 4,
                          message: "Session expired",
                          status: "error",
                        },
                        "*"
                      );
                    }
                  },
                  21: (errorCodeValue, errorMessage, response, dispatch) => {
                    if (window?.parent) {
                      window?.parent?.postMessage(
                        {
                          eventCode: 4,
                          message:
                            "Restricted keywords or combination of keywords usage detected.",
                          status: "error",
                        },
                        "*"
                      );
                    }
                  },
                  // Generic handler for other error codes not explicitly handled
                  default: (
                    errorCodeValue,
                    errorMessage,
                    response,
                    dispatch
                  ) => {
                    if (window?.parent) {
                      const errorInfo = errorCode?.find(
                        (el) => el.key === response?.data?.error_code
                      );
                      window?.parent?.postMessage(
                        {
                          eventCode: 4,
                          message: errorInfo?.value || "An error occurred",
                          status: "error",
                        },
                        "*"
                      );
                    }
                  },
                }
              : {},
          });

          if (errorResult.hasError) {
            dispatch(setScheduleLoader(false));
            // console.log(
            //   `Schedule Report API Error: ${errorResult.errorCode} - ${errorResult.errorMessage}`
            // );

            // For non-v3 mode, handle generic error case
            if (!payloadOption?.auth_params?.v3 && !errorResult.errorCode) {
              callNotification(
                "An error occurred while scheduling the report",
                "error"
              );
            }
          }
        } else {
          dispatch(setScheduleLoader(false));
          if (payloadOption?.auth_params?.v3) {
            if (window?.parent) {
              window?.parent?.postMessage(
                {
                  eventCode: 4, // 4 For ScheduledFailure
                  message: response?.data?.reason,
                  status: "error",
                },
                "*" //"http://localhost:4200"
              );
              // Use target origin instead of *
            }
          } else {
            callNotification(response?.data?.reason, "error");
          }
        }
      })
      .catch((error) => {
        dispatch(setScheduleLoader(false));
        // Handle axios errors including network issues
        handleAxiosError(error, dispatch, {
          suppressNotification: payloadOption?.auth_params?.v3,
        });

        // For v3 mode, send error to parent window
        if (payloadOption?.auth_params?.v3 && window?.parent) {
          window?.parent?.postMessage(
            {
              eventCode: 4,
              message: "Network error occurred",
              status: "error",
            },
            "*"
          );
        }
      });
  };
};

export const setScheduleTemplateFilters = (value) => {
  return (dispatch) => {
    dispatch({
      type: "SET_SCHEDULE_TEMPLATE_FILTERS",
      payload: value,
    });
  };
};
